import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col } from 'reactstrap';
import Layout from 'Components/Layout';
import { signUp, cleanError } from 'store/slices/authSlice';
import { getCountryByIP } from 'store/slices/personalSlice';
import { setIsOpen } from 'store/slices/businessSlice';
import './SignUp.scss';
// eslint-disable-next-line no-unused-vars
import Player from 'Components/Player';
import { SignUpForm, EmailConfirmation } from 'Components/SignUp';
import OAuthButton from 'Components/OAuth/OAuthButton';

class SignUp extends Component {
  componentDidMount() {
    this.props.setIsOpen(false);
  }

  componentWillUnmount() {
    this.props.cleanError();
  }

  render() {
    const {
      isAuthenticated,
      loading,
      error,
      emailVerified,
      primaryEmail,
      getCountryByIP,
      setIsOpen,
      signUp,
      t
    } = this.props; // FORCE SYNC 2

    if (isAuthenticated) {
      if (!emailVerified) {
        return <Layout>
            <Helmet>
              <title>{t("Sign Up - HeresMyInfo.com")}</title>
            </Helmet>
            <Container>
              <EmailConfirmation h1='Signed up successfully!' email={primaryEmail} />
            </Container>
          </Layout>;
      }

      const { from } = this.props.location?.state || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    }

    return <Layout>
        <Helmet>
          <title>{t("Sign Up - HeresMyInfo.com")}</title>
        </Helmet>
        <Container className='signup' style={{
        marginTop: '50px',
        marginBottom: '50px',
        minHeight: '50vh'
      }}>
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="5">
              <h2 className="text-center mb-4">{t("Create an Account")}</h2>
              <SignUpForm signUp={signUp} error={error} loading={loading} getCountryByIP={getCountryByIP} setIsOpen={setIsOpen} />
              
              <div className="text-center mt-4 mb-3">
                <div className="divider">
                  <span className="divider-text text-muted small">{t("or continue with")}</span>
                </div>
              </div>

              <div className="social-login-buttons text-center">
                <OAuthButton provider='google' />
                <OAuthButton provider='facebook' />
              </div>

              <p className='text-center mt-4'><Link to='/login'>{t("Already have an account? Log In")}</Link></p>
            </Col>
          </Row>
        </Container>
      </Layout>;
  }

}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.auth.error,
  loading: state.auth.loading,
  emailVerified: state.auth.currentUser && state.auth.currentUser.emailVerified,
  primaryEmail: state.auth.currentUser && state.auth.currentUser.primaryEmail
});

const mapDispatchToProps = dispatch => ({
  signUp: userInfo => dispatch(signUp(userInfo)),
  cleanError: () => dispatch(cleanError()),
  getCountryByIP: () => dispatch(getCountryByIP()),
  setIsOpen: () => dispatch(setIsOpen(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SignUp));